module.exports = __webpack_public_path__ + "img/lucky_5_regular.6bd76a35.png";